import React from 'react';
import PropTypes from 'prop-types';
// import AORTypes from '../../types';
import analytics from '../../analytics';

class Analytics extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const { userIdentity, userHash } = nextProps;

    if (userIdentity && userIdentity !== prevState.lastIdentity) {
      analytics.create(userIdentity, userHash);

      return {
        lastIdentity: userIdentity,
      };
    }

    return {};
  }

  constructor(props, context) {
    super(props, context);

    this.report = analytics;

    const { userIdentity, userHash } = this.props;

    analytics.create(userIdentity, userHash);

    this.state = {
      lastIdentity: userIdentity,
    };
  }

  render() {
    return (
      <>
      </>
    );
  }
}

Analytics.defaultProps = {
  // config: undefined,
  userHash: undefined,
  userIdentity: undefined,
};

Analytics.propTypes = {
  // config: AORTypes.AWS.Cognito.User,
  userHash: PropTypes.string,
  userIdentity: PropTypes.string,
};

export default Analytics;
